import { RouteConfig } from "vue-router";
import { Route } from "vue-router/types/router";
import config from "@/config";
import { enrichRouteMeta } from "@/router/helpers";
import { profileRoutes } from "@/router/routes/profile";
import { CreatorsTabsEnum } from "@/views/PageCreatorsList/types";

const routes: RouteConfig[] = [
  ...(config.featureLoginAsUser
    ? [
        {
          path: "/login/token/:token",
          name: "loginToken",
          component: () => import("@/views/PageLoginToken"),
          props: true,
        },
      ]
    : []),
  {
    path: "/logout",
    name: "logout",
  },
  ...(!config.featurePrivateProfile ? profileRoutes : []),
  {
    path: "/discover",
    name: "discover",
    props: {
      default: (route: Route) => ({
        onFeed: false,
        tagSlugs: typeof route.query.tag === "string" ? [route.query.tag] : route.query.tag,
        sort: route.query.sort,
      }),
    },
    components: {
      default: () => import("@/views/PageDiscover"),
      unlockFeed: () => import(/* webpackChunkName: "profile" */ "@/views/UnlockFeed"),
    },
  },
  {
    path: "/discover/feed",
    name: "discoverFeed",
    props: {
      default: (route: Route) => ({
        onFeed: true,
        tagSlugs: typeof route.query.tag === "string" ? [route.query.tag] : route.query.tag,
        sort: route.query.sort,
      }),
    },
    components: {
      default: () => import("@/views/PageDiscover"),
      unlockFeed: () => import(/* webpackChunkName: "profile" */ "@/views/UnlockFeed"),
    },
  },
  {
    path: "/discover/lives",
    name: "discoverLives",
    component: () => import("@/views/PageLives"),
  },
  {
    path: "/complaints",
    name: "complaints",
    components: {
      default: () => import("@/views/PageComplaints"),
    },
  },
  {
    path: "/messages/:ownerId/:threadId",
    name: "messagesForAdmin",
    components: {
      default: () => import("@/views/PageMessagesForAdmin"),
    },
    props: {
      default: (route: Route) => ({
        ownerId: route.params.ownerId,
        threadId: route.params.threadId,
      }),
    },
  },
  ...(config.featureDiscoveryCreators
    ? [
        {
          path: "/users",
          name: "usersAll",
          components: {
            default: () => import("@/views/PageCreatorsList"),
            stories: () => import("@/views/Stories"),
          },
          props: { default: () => ({ tab: CreatorsTabsEnum.ALL }) },
        },
        {
          path: "/users/online",
          name: "usersOnline",
          components: {
            default: () => import("@/views/PageCreatorsList"),
            stories: () => import("@/views/Stories"),
          },
          props: { default: () => ({ tab: CreatorsTabsEnum.ONLINE }) },
        },
        {
          path: "/users/live",
          name: "usersLive",
          components: {
            default: () => import("@/views/PageCreatorsList"),
            stories: () => import("@/views/Stories"),
          },
          props: { default: () => ({ tab: CreatorsTabsEnum.LIVE }) },
        },
        {
          path: "/users/recently-active",
          name: "usersRecentlyActive",
          components: {
            default: () => import("@/views/PageCreatorsList"),
            stories: () => import("@/views/Stories"),
          },
          props: { default: () => ({ tab: CreatorsTabsEnum.RECENTLY_ACTIVE }) },
        },
      ]
    : []),
];

export default routes.map(route => enrichRouteMeta(route, {}));
